var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"grid-container"},_vm._l((_vm.container.features),function(feature,i){return _c('rv-feature',{key:i,attrs:{"picture":feature.picture,"picture-position":i % 2 ? 'right' : 'left',"image-options":{ width: 585 }}},[_c('div',{domProps:{"innerHTML":_vm._s(feature.htmlContent)}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }